export default __webpack_public_path__ + "static/app-store-badge-15f01eefb2013206cc7e26d98fbe95fb.svg";